type StatusBadge = { label: string; className: string }

const PENDING = 'bg-light-orange/40 text-secondary'
const DONE = 'bg-light-pink text-primary'
const CANCELED = 'bg-light-red/15 text-light-red'

// `order.status` Medusa ne bouge presque jamais (pending → completed à la main) :
// l'avancement réel d'une commande vit dans `fulfillment_status`.
const WAITING: StatusBadge = { label: 'En attente', className: PENDING }
const DELIVERED: StatusBadge = { label: 'Livrée', className: DONE }
const CANCELED_BADGE: StatusBadge = { label: 'Annulée', className: CANCELED }

const FULFILLMENT_LABELS: Record<string, StatusBadge> = {
  not_fulfilled: WAITING,
  partially_fulfilled: { label: 'En préparation', className: PENDING },
  fulfilled: { label: 'En préparation', className: PENDING },
  partially_shipped: { label: 'Partiellement expédiée', className: DONE },
  shipped: { label: 'Expédiée', className: DONE },
  partially_delivered: { label: 'Partiellement livrée', className: DONE },
  delivered: DELIVERED,
  canceled: CANCELED_BADGE,
}

export const getOrderStatus = (order: {
  status?: string
  fulfillment_status?: string
}): StatusBadge => {
  if (order.status === 'canceled') return CANCELED_BADGE
  if (order.status === 'completed') return DELIVERED

  return (order.fulfillment_status && FULFILLMENT_LABELS[order.fulfillment_status]) || WAITING
}
